/**
 * Azure DevOps Authentication Service
 * Handles authentication flow for Azure DevOps integration
 * Connects the account through provider-token-service
 * All authentication goes through BFF
 */

import providerLinkService from './ProviderLinkService';
import { devLog } from '../utils/devLog';

class AzureDevOpsAuthService {
  /**
   * Check whether the user has connected this provider
   * @returns {Promise<boolean>}
   */
  async isAuthenticated() {
    try {
      const status = await providerLinkService.checkLinkStatus('azure-devops');
      return status.linked;
    } catch (error) {
      console.error('❌ Azure DevOps authentication check error:', error);
      return false;
    }
  }

  /**
   * Disconnect the provider and clear local credentials
   * @returns {Promise<void>}
   */
  async logout() {
    try {
      await providerLinkService.unlinkProvider('azure-devops');
      devLog('✅ Azure DevOps logout successful');
    } catch (error) {
      console.error('❌ Azure DevOps logout error:', error);
      throw error;
    }
  }
}

const AzureDevOpsAuth = new AzureDevOpsAuthService();
export default AzureDevOpsAuth;
